<template>
    <div class="landing-page-home pb-xl-5 pb-xs-0">
        <real-estate-agent
            v-if="parseInt(landingPageTypeId) === LU_LP_TYPES.REAL_ESTATE"
            :landing-page="landingPage"
        />

        <agent-and-loan-officer
            v-if="parseInt(landingPageTypeId) === LU_LP_TYPES.AGENT_AND_LOAN_OFFICER"
            :landing-page="landingPage"
        />

        <baby-or-adoption
            v-if="LIFE_EVENTS.includes(parseInt(landingPageTypeId))"
            :landing-page="landingPage"
        />

        <topic-of-interest-home
            v-if="TOPIC_OF_INTERESTS.includes(parseInt(landingPageTypeId))"
            :landing-page="landingPage"
        />

        <home-ownership-home
            v-if="parseInt(landingPageTypeId) === LU_LP_TYPES.HOME_OWNERSHIP"
            :landing-page="landingPage"
        />
    </div>
</template>

<script>
    import LandingPageAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageAppResource";

    import {ALL as LU_LP_TYPES, LIFE_EVENTS, TOPIC_OF_INTERESTS}
        from "@milestoneslabs/milestones-core-js/src/AppResources/LuLandingPageTypeAppResource";
    import RealEstateAgent from "../../../components/LandingPage/Home/HomeTypes/RealEstateAgent/RealEstateAgent";
    import AgentAndLoanOfficer
        from "../../../components/LandingPage/Home/HomeTypes/AgentAndLoanOfficer/AgentAndLoanOfficer";
    import BabyOrAdoption from "../../../components/LandingPage/Home/HomeTypes/BabyOrAdoption/BabyOrAdoption";
    import TopicOfInterestHome
        from "../../../components/LandingPage/Home/HomeTypes/TopicOfInterestHome/TopicOfInterestHome";
    import HomeOwnershipHome from "../../../components/LandingPage/Home/HomeTypes/HomeOwnershipHome/HomeOwnershipHome";

    export default {
        name: "LandingPage",
        components: {
            HomeOwnershipHome,
            TopicOfInterestHome,
            BabyOrAdoption,
            AgentAndLoanOfficer,
            RealEstateAgent,
        },
        props: {
            landingPage: {
                type: LandingPageAppResource,
                default: () => {
                    return new LandingPageAppResource({});
                }
            }
        },

        data() {
            return {
                LIFE_EVENTS,
                LU_LP_TYPES,
                TOPIC_OF_INTERESTS,
                landingPageUuid: window.landingPageUuid,
                landingPageTypeId: window.landingPageTypeId,
            };
        },
    };
</script>
